import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';

// Icons
import BankIcon from '@material-ui/icons/Payment';
import AddOffersIcon from '@material-ui/icons/CardGiftcard';
import SaveIcon from '@material-ui/icons/Save';

import axios from 'axios';
import Alert from '../utility/Alert';

//App Classes
import CardDiv from '../utility/CardDiv';

import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import EmployeeIcon from '@material-ui/icons/SupervisorAccount';
import DownloadIcon from '@material-ui/icons/CloudDownload';

import LoginTable from './LoginIdTable';
import GenerateID from './GenerateID';
import CsvDownload from 'react-json-to-csv';

import store from '../../store_actions/StudentStore';
import * as action from '../../store_actions/StudentActions';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    width: '100%',
  },
  searchBar: {
    padding: '2px 4px',
    alignItems: 'center',
    width: 400,
  },
  bar: {
    backgroundColor: '#1a237e',
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  btnRightA: {
    position: 'absolute',
    top: theme.spacing.unit * 13,
    right: theme.spacing.unit * 10,
  },
  btnRightB: {
    position: 'absolute',
    bottom: theme.spacing.unit * 12,
    left: theme.spacing.unit * 13,
  },
  searchView: {
    height: 100,
    backgroundColor: 'red',
    width: 400,
  },
  searchBar: {
    padding: '2px',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 10,
    width: 360,
  },
  textField: {
    width: 300,
    height: 40,
    marginLeft: 10,
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
  downloadBtn: {
    width: 160,
    display: 'flex',
    backgroundColor: '#ebeef1',
    border: 0,
  },
  fab: {
    backgroundColor: '#900C3F',
    color: '#FFF',
  },

  extendedIcon: {
    marginRight: theme.spacing.unit,
    color: '#FFF',
  },
});

class GenerateManager extends Component {
  constructor(props) {
    super(props);

    this.makeChanges = this.makeChanges.bind(this);

    this.state = {
      logins: [],
      value: 0,
      isAddNew: false,
      isViewLocation: false,
      generatedData: [],
      search_key: '',
      search_key_activated: '',
    };
  }

  componentWillMount() {
    store.on('change', this.makeChanges);
    action.GetLoginID();
  }

  makeChanges() {
    this.setState({
      logins: store.getLoginID(),
    });
  }

  handleChange = (event, value) => {
    this.setState({ value, search_key_activated: '', search_key: '' });
  };

  onTapSaveChanges = () => {
    this.setState({
      showAlert: true,
      msg: 'All changes will be update on Application API Instantly.',
      title: 'Changes Confirmation!',
    });
  };

  onTapRegister() {
    this.setState({ isAddNew: true });
  }

  onTapBack = () => {
    this.setState({ isAddNew: false, isEdit: false, isViewLocation: false });
    action.GetLoginID();
  };

  onTapViewLocation = (emp) => {
    this.setState({ isViewLocation: true });
  };

  onEditEmp = (emp) => {
    this.setState({
      current_emp: emp,
      isEdit: true,
      isAddNew: true,
    });
  };

  onDeleteEmp(emp) {
    const { _id } = emp;
    this.setState({
      id: _id,
      showAlert: true,
      msg: 'Are you sure to delete the selected ID?',
      title: 'Delete Confirmation!',
    });
  }

  onExecuteDeleteCommand() {
    const { id } = this.state;
    action.DeleteID({ id });
  }

  onTapSearch = () => {
    this.setState({ isSearch: true });
  };

  onTapAdd = () => {
    this.setState({
      isAddNew: true,
    });
  };

  onDisplaySearchView = () => {
    return (
      <div style={styles.searchView}>
        <IconButton className={styles.iconButton} aria-label="Menu">
          <MenuIcon />
        </IconButton>
        <InputBase
          className={styles.input}
          placeholder="Search Employee"
          inputProps={{ 'aria-label': 'Search Employee' }}
        />
        <IconButton className={styles.iconButton} aria-label="Search">
          <SearchIcon />
        </IconButton>
        <Divider className={styles.divider} />
      </div>
    );
  };

  generatedIds = () => {
    const ids = this.state.logins.filter((item) => {
      return item.status === false;
    });

    const filteredIds = ids.map((item) => {
      return { 'Login Id': item.loginId, Password: item.password };
    });

    return filteredIds;
  };

  render() {
    const { classes, employees, attendance } = this.props;

    const {
      value,
      isAddNew,
      showAlert,
      title,
      msg,
      isSearch,
      isEdit,
      current_emp,
      logins,
      search_key,
      search_key_activated,
    } = this.state;

    console.log(search_key_activated);

    if (isAddNew) {
      return (
        <CardDiv
          title={'Generate New IDs'}
          isBack={true}
          onTapBack={this.onTapBack.bind(this)}
        >
          <GenerateID />
        </CardDiv>
      );
    } else {
      return (
        <div>
          <Alert
            open={showAlert}
            onCancel={this.onDismiss.bind(this)}
            onOkay={this.onOkay.bind(this)}
            title={title}
            msg={msg}
          />

          <CardDiv
            title={'Generate Login ID'}
            isAdd={true}
            onTapAdd={this.onTapAdd.bind(this)}
          >
            <Tabs
              value={value}
              onChange={this.handleChange}
              scrollable
              scrollButtons="on"
              indicatorColor="secondary"
              textColor="secondary"
            >
              <Tab label="Available IDs" icon={<EmployeeIcon />} />
              <Tab label="Active Ids" icon={<EmployeeIcon />} />
              <CsvDownload
                className={classes.downloadBtn}
                data={this.generatedIds()}
              >
                <Fab
                  variant="extended"
                  size="medium"
                  aria-label="Delete"
                  className={classes.fab}
                >
                  <DownloadIcon className={classes.extendedIcon} />
                  Download
                </Fab>
              </CsvDownload>
            </Tabs>

            {value === 0 && (
              <TabContainer>
                <div>
                  <div className={classes.searchBar}>
                    <InputBase
                      className={classes.textField}
                      placeholder="Search Login ID"
                      onChange={(e) => {
                        this.setState({
                          search_key: e.target.value.toLowerCase(),
                        });
                      }}
                    />
                    <IconButton
                      className={classes.iconButton}
                      aria-label="Search"
                    >
                      <SearchIcon />
                    </IconButton>
                  </div>

                  {logins !== undefined && (
                    <LoginTable
                      onEditEmp={this.onEditEmp.bind(this)}
                      onDeleteEmp={this.onDeleteEmp.bind(this)}
                      data={
                        search_key === ''
                          ? logins.filter((item) => {
                              return item.status == false;
                            })
                          : logins.filter((item) => {
                              return (
                                item.status == false &&
                                item.user_id.toLowerCase().match(search_key)
                              );
                            })
                      }
                    />
                  )}
                </div>
              </TabContainer>
            )}

            {value === 1 && (
              <TabContainer>
                <div>
                  <div className={classes.searchBar}>
                    <InputBase
                      className={classes.textField}
                      placeholder="Search Login ID"
                      onChange={(e) => {
                        this.setState({
                          search_key_activated: e.target.value.toLowerCase(),
                        });
                      }}
                    />
                    <IconButton
                      className={classes.iconButton}
                      aria-label="Search"
                    >
                      <SearchIcon />
                    </IconButton>
                  </div>

                  {logins !== undefined && (
                    <LoginTable
                      onEditEmp={this.onEditEmp.bind(this)}
                      onDeleteEmp={this.onDeleteEmp.bind(this)}
                      data={
                        search_key_activated === ''
                          ? logins.filter((item) => {
                              return item.status == true;
                            })
                          : logins.filter((item) => {
                              return (
                                item.status == true &&
                                item.user_id
                                  .toLowerCase()
                                  .match(search_key_activated)
                              );
                            })
                      }
                    />
                  )}
                </div>
              </TabContainer>
            )}
          </CardDiv>
        </div>
      );
    }
  }

  //ALERT
  onDismiss = () => {
    this.setState({ showAlert: false });
  };

  onOkay = () => {
    this.setState({ showAlert: false });
    this.onExecuteDeleteCommand();
  };
}

GenerateManager.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GenerateManager);
